import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getDistrictUrl, getBaseDomain } from '../../utils/domainUtils';
import './DistrictsList.css';

const FormInstancesList = () => {
  const navigate = useNavigate();

  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDistricts();
  }, []);

  const fetchDistricts = async () => {
    try {
      const response = await axios.get('/api/districts');
      setDistricts(response.data);
    } catch (error) {
      console.error('Failed to fetch districts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Form Instances by District</h2>
        <Link to="/superadmin/form-instances/create" className="btn-primary">Create Form Instance</Link>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>District Name</th>
            <th>Subdomain</th>
            <th>Contact Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {districts.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center' }}>No districts found</td>
            </tr>
          ) : (
            districts.map(district => (
              <tr key={district.id}>
                <td><strong>{district.district_name}</strong></td>
                <td>
                  <a 
                    href={getDistrictUrl(district.subdomain)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {district.subdomain}.{getBaseDomain()}
                  </a>
                </td>
                <td>{district.contact_email}</td>
                <td className="actions">
                  <button 
                    onClick={() => navigate(`/superadmin/form-instances/${district.subdomain}`)} 
                    className="btn-primary"
                  >
                    View Form Instances
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FormInstancesList;

